export enum EUserStatus {
  Active = 0,

  Inactive = 5,

  Dismissed = 10
}
